import { render, staticRenderFns } from "./RegisterRestaurant.vue?vue&type=template&id=73d658c2&scoped=true"
import script from "./RegisterRestaurant.vue?vue&type=script&lang=js"
export * from "./RegisterRestaurant.vue?vue&type=script&lang=js"
import style0 from "./RegisterRestaurant.vue?vue&type=style&index=0&id=73d658c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d658c2",
  null
  
)

export default component.exports